import makeService from './api';

export default makeService('credit_transfer_payment_runs');
